import React from "react";
import SidebarLayout from "../../components/sidebarLayout";
import Footer from "../../components/footer";
import NavigationBar from "../../components/navbar";
import menuData from "../../data/menuData"; // 메뉴 데이터 가져오기
import { Row, Col } from "react-bootstrap";
import "./greeting.css"; // CSS 파일 추가

export default function Greeting() {
  const greetingMenu = menuData.find((menu) => menu.title === "포럼소개");

  return (
    <div>
      <SidebarLayout menu={greetingMenu}>
        <div className="greeting-section">
          {/* 이미지 섹션 */}
          <div className="greeting-image">
            <img
              src="/images/member/member1.jpeg" // 이미지 URL
              alt="윤대순 이사장"
              className="profile-image"
            />
          </div>

          {/* 인삿말 섹션 */}
          <div className="greeting-content">
            {/* <h1 className="greeting-title">인사말</h1> */}
            <p>
              안녕하십니까? <br></br>사단법인 한국관광산업포럼 이사장 겸
              경기대학교 명예교수 윤대순입니다. <br></br>먼저, 본 포럼의 운영을
              위해 헌신해 준 임원진 및 회원분들에게 진심 으로 감사드립니다
            </p>
            <p>
              사람이 집을 떠나 즐거움(樂), 친목도모(親), 건강(體), 인격도야(德),
              견문확대(知), 효도(孝), 충성(忠), 업무(事), 일탈(脫) 등을 목적으로
              여행하여 진(眞), 선(善), 미(美)를 추구하는 체험과정의 총체가
              관광이며, 관광하는 마음으로 현실을 인정하고 만족하면서 최선을 다
              하면 성공적인 인생과 행복한 삶이 됩니다.
            </p>
            <p>
              이러한 학문적 토대를 바탕으로 대한민국 관광산업 발전에 기여하고자
              2005년 설립된 본 포럼은 ‘관광학’의 학문적 위상제고와 인재양성 등
              다양한 노력을 경주해 왔으며, 산-관-학-연 연계를 통한 지역관광
              활성화, 관광업계 맞춤형 정책발굴 등을 통해 관광대국을 실현하는
              글로벌 학술단체로 자리매김 해 나아가겠습니다.
            </p>
            <p>
              아울러, 관광으로 모두가 행복한 대한민국, 관광산업의 발전을 통한
              경제강국 실현을 위한 작은 밑거름이 되겠습니다.
            </p>
            <p>
              본 포럼의 발전과 한국 관광산업의 미래를 위한 지속적인 관심과
              성원을 당부드리며, 모든 분의 ‘관광하는 삶’을 응원합니다.
            </p>
            <p>
              <strong>윤 대 순</strong> <br />
              (관광경영학박사 & 교육학박사)
            </p>
          </div>
        </div>
      </SidebarLayout>
    </div>
  );
}
